<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <h2 mat-dialog-title>{{ data.project ? 'Edit Project' : 'Add New Project' }}</h2>
    <mat-icon>drag_indicator</mat-icon>
</div>
<mat-dialog-content class="dialog-content">
    <mat-tab-group dynamicHeight="true">
        <mat-tab label="Details">
            <form [formGroup]="projectForm">
                <mat-form-field appearance="fill" class="effort-chooser margin-sm-bottom">
                    <mat-label>Effort</mat-label>
                    <input matInput formControlName="selectedEffort" />
                    <button class="margin-xs-right" mat-button matSuffix (click)="openEffortSelectDialog()">
                        Select
                    </button>
                </mat-form-field>

                <mat-form-field appearance="outline" class="full-width margin-sm-bottom">
                    <mat-label>Project Title</mat-label>
                    <input matInput formControlName="title" (blur)="keyify($event)" #titleInput />
                </mat-form-field>

                <mat-form-field appearance="outline" class="full-width margin-sm-bottom">
                    <mat-label>Description</mat-label>
                    <input matInput formControlName="description" />
                    <mat-hint align="start">This will show as help text in the timesheet and other places.</mat-hint>
                </mat-form-field>

                <mat-form-field appearance="fill" class="full-width margin-sm-bottom">
                    <mat-label>Project Key</mat-label>
                    <input matInput formControlName="key" appSlugInput [sourceInput]="titleInput" />
                </mat-form-field>

                <div class="row-grouping">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Owner</mat-label>
                        <input matInput formControlName="owner" />
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Customer</mat-label>
                        <input matInput formControlName="customer" />
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>OAccount</mat-label>
                        <input matInput formControlName="oAccount" />
                        @if (projectForm.get('oAccount')?.invalid) {
                            <mat-error>
                            Must be 3 digits &gt; 000.
                            </mat-error>
                        }
                    </mat-form-field>
                </div>

                <mat-checkbox style="align-self:flex-start;" formControlName="isBillable">
                    Project is billable.
                </mat-checkbox>

                <div class="col-grouping">
                    <mat-form-field appearance="outline" class="full-width" #mfk>
                        <mat-label>MFK</mat-label>
                        <input matInput formControlName="mfk" />
                        <mat-hint align="end">FND OG DEPT SDEPT GRANTPRG IACC OAC DACCT FN CCTR</mat-hint>
                        @if (projectForm.get('mfk')?.pending) {
                            <mat-hint>Checking validity...</mat-hint>
                        } @else if (projectForm.get('mfk')?.invalid) {
                            <mat-error>
                                <div style="margin-bottom: 0.5em;">
                                    @for (name of mfkPartNames; track name; let i = $index) {
                                        <span [class]="{ 'highlight-mfk-error' : mfkErrorInPart(i, projectForm.get('mfk')?.getError('MFK')) }" [title]="mfkHelpTexts[i] + ' - ' + mfkPartNames[i].length + ' digits.'">{{ name }}</span>&nbsp;
                                    }
                                </div>
                                MFK error: {{projectForm.get('mfk')?.getError('MFK')}}
                            </mat-error>
                        } @else if (projectForm.get('allowInvalidMFK')?.value) {
                            <mat-hint class="warning-mfk"><mat-icon>warning</mat-icon> Allowing invalid MFK.</mat-hint>
                        } @else if (projectForm.get('mfk')?.value?.length) {
                            <mat-hint class="valid-mfk">MFK is valid!</mat-hint>
                        }
                        <button mat-icon-button matSuffix type="button" (click)="formatMFKWithSpaces()">
                            <mat-icon>space_bar</mat-icon>
                        </button>
                    </mat-form-field>
                    <mat-checkbox formControlName="allowInvalidMFK">Allow invalid MFK.</mat-checkbox>
                    <mat-checkbox formControlName="hasNonbillable">Allow entry of non-billable hours.</mat-checkbox>
                </div>

                <mat-checkbox formControlName="isDeleted">Is Archived</mat-checkbox>
            </form>
        </mat-tab>
        <mat-tab label="Custom Values">
            <div class="key-value-editor">
                <div class="kvp-row">
                    <div class="key header">Key</div>
                    <div class="equals header">=</div>
                    <div class="value header">Value</div>
                    <div class="row-tools header"></div>
                </div>
                @for (kvp of customValues | keyvalue; track kvp; let i = $index) {
                <div class="kvp-row kvp-body">
                    <div class="key">
                        <mat-form-field appearance="outline" class="kvp-input" title="The custom key value.">
                            <label [attr.for]="'custom-key-input' + i" class="visually-hidden">
                                custom key input
                            </label>
                            <input [id]="'custom-key-input' + i" matInput [(ngModel)]="kvp.key">
                        </mat-form-field>
                    </div>
                    <div class="equals">=</div>
                    <div class="value">
                        <mat-form-field appearance="outline" class="kvp-input" title="The custom value value.">
                            <label [attr.for]="'custom-value-input' + i" class="visually-hidden">
                                custom value input
                            </label>
                            <input [id]="'custom-key-input' + i" matInput [(ngModel)]="kvp.value">
                        </mat-form-field>
                    </div>
                    <div class="row-tools">
                        <button mat-icon-button
                            (click)="removeCustomValue(kvp.key)"><mat-icon>delete</mat-icon></button>
                    </div>
                </div>
                }
                <!-- <div class="kvp-row empty-table" *ngIf="(customValues | keyvalue)?.length == 0">
                    <div class="full-width">
                        No custom values yet. You can add them below.
                    </div>
                </div> -->
                <div class="kvp-row new">
                    <div class="key-new">
                        <mat-form-field appearance="outline" class="kvp-input" title="The custom key value.">
                            <label [attr.for]="'custom-key-input-new'" class="visually-hidden">
                                custom key input
                            </label>
                            <input [id]="'custom-key-input-new'" #newKeyInput matInput [(ngModel)]="keyNew">
                        </mat-form-field>
                    </div>
                    <div class="equals">=</div>
                    <div class="value-new">
                        <mat-form-field appearance="outline" class="kvp-input" title="The custom value value.">
                            <label [attr.for]="'custom-value-input-new'" class="visually-hidden">
                                custom value input
                            </label>
                            <input [id]="'custom-value-input-new'" matInput [(ngModel)]="valueNew"
                                (keyup.enter)="addCustomValue()">
                        </mat-form-field>
                    </div>
                    <div class="row-tools">
                        <button mat-icon-button [disabled]="!keyNew"
                            (click)="addCustomValue()"><mat-icon>add</mat-icon></button>
                    </div>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>

</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-flat-button color="primary" (click)="save()"
        [disabled]="projectForm.invalid || projectForm.pending || !canSave">Save</button>
    <button mat-button (click)="reset()">Reset</button>
    <button mat-button (click)="dialogRef.close()">Cancel</button>
</mat-dialog-actions>
